import service from '@/utils/request';
export var couponList = function couponList(data) {
  return service({
    url: "/xcpOpsManager/coupon/getList",
    method: 'post',
    data: data
  });
};
export var couponBatchList = function couponBatchList(data) {
  return service({
    url: "/xcpOpsManager/coupon/getBatchList",
    method: 'post',
    data: data
  });
};
export var createBatch = function createBatch(data) {
  return service({
    url: "/xcpOpsManager/coupon/createBatch",
    method: 'post',
    data: data
  });
};
export var couponSync = function couponSync(data) {
  return service({
    url: "/xcpOpsManager/coupon/sync",
    method: 'post',
    data: data
  });
};